<!-- 评论模板，提供给显示用户评论记录和用户所喜欢的评论记录 -->
<!-- 如果为了性能的话，不要每次获取 comments，读取后缓存到 Client，但是问题来了，要考虑 client 上新添加的 comments 与 his comments 聚合
     考虑到查看用户评论很可能是一个低频事件，因此暂时不做这个优化。
-->
<!-- 现有遗留了一个小的 BUG，就是评论展开的时候，会一次性读取两页的内容，这个可能和窗口的高度有关，因为一次性加载了 12 个评论，高度早已超过了
     Dialog 的可显示高度。因此会额外加载一页。因此这里遗留了一个参数 isCreateScroll 就是想控制 scroll 的创建时机，等待第一次加载完毕后再初
     始化 scroller。现在是通过 setTimeout 2s 来模拟的，第一次打开评论还真的只加载一次了，但是第二个第三次又会重复加载两次了。
     但是问题是，为什么 list entity page 超过高度了也不会多加载一次？难道是因为 list entity page 监听的是 Window？
     TODO 不过这个问题也不是那么的严重，留待以后再处理吧。思路可以是延迟 scroller 的创建时机。
 -->
<template>
    <my-dialog ref="dialog" title="我的评论记录">
        <div ref='list-wrap' class="list-wrap">
            <!--注意，el-table 的高度不受 list-wrap div 的限制，因此 mugen scroll 最好是绑定到 el-table 上-->
            <!--el-table 响应式，总宽度 100，然后设置 -->
            <el-table :data="tableData" class="list-table" stripe show-header :size="tableSize" :empty-text="tableDesc">
                <el-table-column prop="thumbnail" label="" :width="responsiveColumnWidth.imgWidth">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center">
                            <!-- BUG, 不能使用 lazy，否则关闭后再次打开 thumbnail 消失，目前原因不明; Deprecated -->
                            <!-- <el-image fit="fit" :src="scope.row.thumbnail" @click.native="navigate(scope.row.shortcode)" style="cursor:pointer"></el-image>-->
                            <sy-loading-image :src="scope.row.thumbnail"
                                              style-str="object-fit:cover;cursor:pointer;width:100%;height:100%"
                                              @click.native="popupEntity(scope.row.shortcode)">
                                <img slot="loading"
                                     style="object-fit:cover;cursor:pointer;width:100%;height:100%"
                                     :src="require('@/assets/transparent-gray_320x320.png')"/>
                            </sy-loading-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="用户名" show-overflow-tooltip :width="responsiveColumnWidth.usernameWidth">
                    <template slot-scope="scope">
                        <!-- BUG, 不能使用 lazy，否则关闭后再次打开 thumbnail 消失，目前原因不明-->
                        <!-- <div class="comment" @click="popupEntity(scope.row.shortcode)">{{scope.row.username}}</div> -->
                        {{scope.row.username}}
                    </template>
                </el-table-column>
                <el-table-column prop="comment" label="评论" show-overflow-tooltip :width="responsiveColumnWidth.contentWidth">
                    <template slot-scope="scope">
                        <!-- 备注，这里不能使用 el-link 组件，否则 overflow-elipsis 会失效 -->
                        <!-- 不能通过局部样式 el-tooltip__popper 的修改来禁止弹出，索性就直接禁用点击评论跳转功能，这样就避免了进入新的 enttiy 页面莫名弹出 tooltip 的问题了 -->
                        <!-- <div class="comment" @click="popupEntity(scope.row.shortcode)">{{scope.row.comment}}</div>-->
                        <div class="comment">{{scope.row.comment}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="date" label="日期" :width="responsiveColumnWidth.dateWidth">
                    <template slot-scope="scope">
                        <!-- 备注，这里不能使用 el-link 组件，否则 overflow-elipsis 会失效 -->
                        <div class="comment" @click="popupEntity(scope.row.shortcode)">{{scope.row.date}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <no-signal
                v-if='noSignalVisible'
                ref="noSignal"
                :display-mode="noSignalDisplayMode"
                :retry-handlers="[nextPage]"
                :retry-basis="false"
                :margin-top="0"></no-signal>
            <!-- 导致 comments 初始化过程全部加载的原因是允许了 handle-on-mount，这里比较特殊，list-wrap 是 v-if 创建的，而 mugen-scroll
                 是通过同一个 v-if 创建的，因此导致 mugen scroll 初始化的时候，其实 list-wrap 还没有创建好，如果允许 handle-on-mount 会
                 导致 mugen scroll 找不到 list-wrap。因此必须将 handle-on-mount 给禁止掉。
                 --------------------------
                 备注: 这里 mugrn scroll 滚动的逻辑是，mugen scroll 监听 list-table 是否触底 list-wrap 来进行滚动。
                 --------------------------
            -->
            <mugen-scroll :handler="nextPage"
                          :handle-on-mount="false"
                          :should-handle="!loading && !isLastPage"
                          scroll-container="list-wrap" >
                <!-- 不要和全局的 loading 冲突 -->
                <loading :text="null" v-show="loading && !isLastPage"></loading>
            </mugen-scroll>
        </div>
        <popup-entity
            v-if="allowPopup"
            :z-index="20"
            :close-handler="closeHandler"
        />
    </my-dialog>
</template>

<script>
    import {ShowEntityMode, DateFormat, isPhoneAgent, GlobalLoading, errorMessage} from "../../../utils";
    import SyLoadingImage from "../../commons/SyLoadingImage";
    import PopupEntity from "../../entity/PopupEntity";
    import {Entity} from "../../../data/converter";
    import MyDialog from "../../commons/MyDialog";
    import {getHisComments} from "../../../data/comment";
    import MugenScroll from '@shangyang/vue-mugen-scroll'
    import {getEntity} from "../../../data/entity";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "UserComments",
        components: {MyDialog, MugenScroll, SyLoadingImage, PopupEntity},
        props: {
            getCommentsHandler: Function
        },
        data() {
            return {
                tableData: [],
                tableDesc: '数据加载中...',
                noData: false,
                loading: false,
                isLastPage: false,
                isCreateScroll: true,
                pageNum: 1,
                allowPopup: false,
                noSignalVisible: false,
                noSignalDisplayMode: 'vertical'
            }
        },
        computed: {
            isPhoneAgent: function(){
                return isPhoneAgent();
            },
            hasComments: function(){
                return this.tableData.length > 0;
            },
            isShowOverflowTooltips () {
                return !isPhoneAgent()
            },
            tableSize: function(){
                if(isPhoneAgent()){
                    return 'mini';
                }else{
                    return 'medium'
                }
            },
            /**
             * el-table-column 的响应式：很垃圾，必须给定一个数值，而默认情况下，el-table-column 是以等分屏幕宽度作为比例显示的，
             * 比如 iphone 5 屏幕的尺寸是 320，那么默认情况下，4 个 column 的话等分后每个 column 宽度是 80。经过精密的计算，
             * 在 iphone 尺寸下，只要日期的比例在 0.1875，那么 el-table-column 在手机侧可以做到响应式了.
             */
            responsiveColumnWidth: function(){
                const table_max_width = 620
                let max_width = window.innerWidth > 700 ? table_max_width : window.innerWidth;
                let rspvWidth = {}
                if(isPhoneAgent() && max_width < 375){
                    rspvWidth.imgWidth = 50
                }else{
                    rspvWidth.imgWidth = 100
                }

                let screenWidthRemains = max_width - rspvWidth.imgWidth;
                console.log('screenWidthRemains:', screenWidthRemains);
                // 下面就是各自调整除了图片以后的 username、内容、日期 columns 的宽度了
                rspvWidth.usernameWidth = screenWidthRemains * 0.25
                rspvWidth.contentWidth = screenWidthRemains * 0.45
                rspvWidth.dateWidth = screenWidthRemains * 0.3
                console.log(JSON.stringify(rspvWidth, null, 4))
                return rspvWidth
            }
        },
        methods: {
            show(){
                // 延时显示
                setTimeout(()=>{
                    this.$refs.dialog.show();
                }, 300);
                this.__init();
            },

            __init(){
                this.reset();
                this.$nextTick(()=>{
                    this.nextPage();
                })
            },

            reset() {
                this.tableData = []; // reset
                this.pageNum = 1; // reset
                this.isLastPage = false; // reset
                this.loading = false;
                this.tableDesc = '数据加载中...';
                this.noData = false;
                this.noSignalVisible = false; // 显示 no signal comp
            },

            hide(){
                setTimeout(()=>{
                    this.$refs.dialog.hide();
                }, 300)
            },

            async popupEntity(shortcode){
                try {
                    GlobalLoading.start();
                    let e = await getEntity(shortcode);
                    this.$store.commit('setShowEntityMode', ShowEntityMode.PopupPageMode);
                    // cache the popping up entity，注意：popup entity 就是从这里获取的 entity
                    this.$store.commit('setCurrentEntity', e);
                    this.allowPopup = true;
                } catch(error) {
                    console.error(error);
                    throw error;
                } finally {
                    GlobalLoading.stop();
                }
            },

            closeHandler(){
                this.allowPopup = false;
            },

            async nextPage(){
                console.log(`user comments, next page called with page num: ${this.pageNum}`);
                this.loading = true;
                try {
                    let comments = await this.getCommentsHandler(this.pageNum); // 注意，pageNum start from 1
                    console.log(`user comments loaded as ${comments}`);
                    if (comments === undefined || comments === null || comments.length === 0) {
                        if (this.pageNum === 1) {
                            this.noData = true;
                            this.tableDesc = '暂无数据';
                        } else
                            this.isLastPage = true;
                    } else {
                        for (let c of comments) {
                            this.tableData.push({
                                thumbnail: Entity.getPublicResPath(c.shortcode, c.thumbnail),
                                username: c.username,
                                comment: c.text,
                                shortcode: c.shortcode,
                                date: DateFormat.responsiveYyMmDdFormat(c.create_ts)
                            })
                        }
                        this.pageNum += 1;
                    }
                    this.noSignalVisible = false; // 显示 no signal comp
                } catch (error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if (error instanceof TimeoutError || error instanceof NetworkError) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                        if (this.pageNum === 1){
                            this.noSignalDisplayMode = 'vertical'
                        } else { // page num > 1
                            this.noSignalDisplayMode = 'horizental'
                        }
                    }
                    this.tableDesc = '数据加载失败'
                } finally {
                    this.loading = false;
                    console.log('user comments, set loading to false, this.loading: ', this.loading);
                }
            }
        }
    }
</script>
<style scoped>

    /* 靠，element-ui 的 el-table 默认使用的是 position:relative 导致 PC 端下拉刷新获取最新页面的时候不回弹，结果一股脑全部加载完所有分页 */
    /deep/ .el-table{
        position: unset !important;
    }

    /* 使用 position fixed 固定表头，因为脱离了文档流，因此它会遮挡住部分主体内容，让主体内容 margin-top 的方式进行微调 */
    /* @deprecated 后来发现，如果这样调整，要微调的东西实在是太多了，其实很简单的一个需求，只要 header 与 body 分开写即可，但是 el-table 不支持这样做 */
    /* /deep/ .el-table__header-wrapper{
        position: fixed;
        top: 108px;
        z-index: 100
    } */

    /* 修复通过 position fixed 的方式固定表头遗留的问题，部分主体内容被遮挡住了 */
    /* small mobile screen */
    /*
    /deep/ .el-table__body {
        margin-top: 34px;
    } */

    /deep/ .list-table{
        width: 100%;
        height: auto;
    }

    /deep/ .el-divider--horizontal{
        margin: 0 !important;
    }

    /* 切记，hover 事件只在 PC 端添加，否则 IOS H5 会出现 double click link 才能生效的问题 */
    @media (min-width: 736px) {
        .comment {
            cursor: pointer;
        }

        .comment:hover {
            text-decoration: underline;
            color: #CB0101;
        }
    }

    /* mobile screen */
    @media (max-width: 735px){
        /deep/ .list-wrap{
            padding: 0 0 0 0;
        }

        /* 禁用 element-ui tooltip 的弹出窗口；目前主要是作用于手机端用户评论界面，弹出窗口影响 UE */
        /* 遗憾的是，因为 el-tootip 是动态添加到 body 中的，因此下面的这个方式在局部环境中无效 */
        /deep/ .el-tooltip__popper {
            display: none !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserCommentsTemplate.vue